const STORAGE_KEY = "review_modal_shown"

/** True after the review modal has auto-shown once. */
export function hasShownReviewModal(): boolean {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === "1"
  } catch {
    return false
  }
}

/** Persist that the review modal was auto-shown. */
export function markReviewModalShown(): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, "1")
  } catch {
    /* ignore */
  }
}
